// A message for the login screen, left by whatever sends the user there (an
// ended session, a finished first-login password change). Kept in
// sessionStorage because those paths reload the page; the login screen shows
// it once.
const KEY = "loginNotice";

/** kind: "info" or "error" */
export function setLoginNotice(text, kind = "info") {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ text, kind }));
  } catch (error) {
    // storage blocked: the login screen simply shows no notice
  }
}

export function peekLoginNotice() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || null;
  } catch (error) {
    return null;
  }
}

export function clearLoginNotice() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (error) {
    // nothing to clear
  }
}
